"use client";

import { RouteErrorBoundary } from "@/components/states/route-error";

/**
 * Error boundary for the public marketing pages. Keeps the `AppShell` chrome
 * while recovering the page body.
 */
export default function MarketingError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteErrorBoundary {...props} source="boundary:(marketing)" />;
}
